import PropTypes from "prop-types";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useState } from "react";
import Select from "react-select";

const CampaignMediaBuyerModal = props => {
  const {
    isOpen,
    toggle,
    data,
    usersInfo,
    addCampaignMediaBuyer,
    updateCampaignMediaBuyerProfile,
    editData,
  } = props;

  const [selectedUser, setSelectedUser] = useState(data.user);

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      let currentUser = usersInfo.findIndex(i => i.label === editData.email);
      handleSelectUser(usersInfo[currentUser]);
    } else {
      handleSelectUser("");
    }
  }, [isOpen]);

  const handleSelectUser = selectedUser => {
    setSelectedUser(selectedUser);
  };

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0 && selectedUser?.label !== undefined) {
      let mediaBuyerData = {
        ...params,
        user: selectedUser.value,
      };
      if (editData !== null) {
        updateCampaignMediaBuyerProfile(editData.id, mediaBuyerData, data);
        toggle();
      } else {
        addCampaignMediaBuyer(mediaBuyerData, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} campaign media buyer
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <FormGroup className="mb-3">
                <Label>Media buyer number</Label>
                <AvField
                  name="number"
                  type="text"
                  placeholder="Media buyer number..."
                  errorMessage="This value is required."
                  value={editData?.number || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter number",
                    },
                    maxLength: {
                      value: 150,
                      errorMessage: "Max 150 characters.",
                    },
                    minLength: { value: 1, errorMessage: "Min 1 character" },
                  }}
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>User</Label>
                <Select
                  value={selectedUser}
                  onChange={handleSelectUser}
                  options={usersInfo}
                  placeholder="Select user..."
                  classNamePrefix="select2-selection"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_campaignmediabuyermodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CampaignMediaBuyerModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  usersInfo: PropTypes.any,
  addCampaignMediaBuyer: PropTypes.func,
  updateCampaignMediaBuyerProfile: PropTypes.func,
  editData: PropTypes.any,
  permissions: PropTypes.any,
};

export default CampaignMediaBuyerModal;
